var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSetting = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M10.26 3.45 9.42 2c-.28-.48-.89-.64-1.36-.37l-2.61 1.5c-.48.28-.64.89-.37 1.37l.84 1.45c.21.37.15.81-.11 1.15-.49.63-.9 1.33-1.2 2.08-.16.39-.52.66-.94.66H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h1.67c.42 0 .78.27.94.66.31.76.71 1.46 1.2 2.08.26.33.32.78.11 1.15l-.84 1.45c-.28.48-.11 1.09.37 1.37l2.61 1.5c.48.28 1.09.11 1.36-.37l.84-1.45c.2-.34.58-.55.98-.49a8.934 8.934 0 0 0 2.54 0c.39-.06.78.15.98.49l.84 1.45c.28.48.89.64 1.36.37l2.61-1.5c.48-.28.64-.89.37-1.37l-.84-1.45c-.21-.37-.15-.81.11-1.15.49-.63.9-1.33 1.2-2.08.16-.39.52-.66.94-.66h1.67c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-1.67c-.42 0-.78-.27-.94-.66-.31-.76-.71-1.46-1.2-2.08-.26-.33-.32-.78-.11-1.15l.84-1.45c.28-.48.11-1.09-.37-1.37l-2.61-1.5A.99.99 0 0 0 15.6 2l-.84 1.45c-.2.34-.58.55-.98.49a8.934 8.934 0 0 0-2.54 0c-.39.06-.78-.15-.98-.49"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12.5 16.35a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
})));
export default SvgSetting;